import { Model } from 'pinia-orm';
import { Str, Uid, HasMany, Attr, Bool } from 'pinia-orm/decorators';
import { CourseSection } from './CourseSection';
import type { ApiCourseCourse } from 'src/types/contentTypes';
import type { StrapiAttr, StrapiMedia } from 'src/types/strapi';

/** Scalar field types are derived from the backend schema — see src/types/strapi.ts. */
type CourseAttr<K extends keyof ApiCourseCourse['attributes']> = StrapiAttr<
  ApiCourseCourse,
  K
>;

export class Course extends Model {
  static override entity = 'courses';

  @Uid() declare id: number;
  @Str(null) declare documentId: string | null;
  @Str('') declare course_name: CourseAttr<'course_name'>;
  @Str('') declare subtitle: CourseAttr<'subtitle'>;
  @Str('') declare description: CourseAttr<'description'>;
  @Str('') declare instructions: CourseAttr<'instructions'>;
  // Strapi models `categories` as a oneToMany relation; this app consumes it
  // already flattened to names, so it stays hand-typed.
  @Str('') declare categories: string[];
  @Bool(false) declare is_reset: CourseAttr<'is_reset'>;
  @Bool(false) declare is_show_in_store: CourseAttr<'is_show_in_store'>;
  @Bool(false) declare is_free: CourseAttr<'is_free'>;
  @Attr(null) declare tags: CourseAttr<'tags'> | null;

  // Strapi's Media attribute does not resolve to a usable type, so this uses the
  // explicit media shape from src/types/strapi.ts instead of deriving.
  @Attr(null) declare image: StrapiMedia | null;
  @Attr(null) declare user_course_id: number;
  @HasMany(() => CourseSection, 'course_id')
  declare course_sections: CourseSection[];
}
